import { FormattedMessage } from 'react-intl';
import React from 'react';
import { FULFILLMENTS_PENDING_VIEW_ID, FULFILLMENTS_VIEW_ID } from './view-id-constants';

export const FulfillmentsPending = {
  label: <FormattedMessage defaultMessage='Pending' description='shipping page left nav item for pending fulfillments' id='rrIy18' />,

  expandedDescription: (
    <FormattedMessage defaultMessage='Fulfillments / Pending' description='shipments page grid header, fulfillments.pending' id='oIBERr' />
  ),

  id: FULFILLMENTS_PENDING_VIEW_ID,
  navigationOverride: '/shipments/fulfillments/pending',
  parentId: FULFILLMENTS_VIEW_ID,
};
